/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDetailsDto } from './CompanyDetailsDto';
export type InvoiceDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    invoiceType: InvoiceDto.invoiceType;
    manufacturerDetails: CompanyDetailsDto;
    invoiceState?: InvoiceDto.invoiceState;
    invoiceNumber?: string;
    invoiceDate?: string;
    dueDate?: string;
    paidOn?: string;
    note?: string;
    containsCredit?: boolean;
    creditNumber?: string;
    creditDate?: string;
    updateCompanyToFullBeamLicense?: boolean;
};
export namespace InvoiceDto {
    export enum invoiceType {
        COMPANY_REGISTRATION = 'COMPANY_REGISTRATION',
        PRODUCT_APPROVAL = 'PRODUCT_APPROVAL',
    }
    export enum invoiceState {
        OPEN = 'OPEN',
        REQUESTED = 'REQUESTED',
        OVERDUE = 'OVERDUE',
        PAID = 'PAID',
    }
}

